import { Link } from "react-router-dom";
import { Card } from "./Card";
import "../components/ProductsSection.css";
import Tab1 from "../img/products/1.png";
import Tab2 from "../img/products/2.png";
import Tab3 from "../img/products/3.png";
import Tab4 from "../img/products/4.png";
import Tab5 from "../img/products/5.png";
import Tab6 from "../img/products/6.png";
import Tab7 from "../img/products/7.png";
import Tab8 from "../img/products/8.png";
import Tab9 from "../img/products/9.png";
import Tab10 from "../img/products/10.png";
import Tab11 from "../img/products/11.png";
import Tab12 from "../img/products/12.png";
import Tab13 from "../img/products/13.png";

export default function ProductsSection() {
  const products = [
    {
      id: 1,
      name: "GERDHEAL DSR",
      description: "Rabeprazole Sodium 20mg & Domperidone (SR) 30 mg Caspules",
      category: "Gastroenterology",
      image: Tab1,
    },
    {
      id: 2,
      name: "Natodrive-MNT",
       description:
        "Pregabalin 75mg, Mecobalamin 1500 mcg. & Nortriptyline 10mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      category: "Lorem Ipsum ",
      image: Tab2,
    },
    {
      id: 3,
      name: "Natodrive-SP",
      description: "Aceclofenac 100mg + Paracetamol 325mg & Serratiopeptidase 15mg Tablets",
      category: "Lorem Ipsum",
      image: Tab3,
    },
    {
      id: 4,
      name: "Semecal-P",
      category: "Lorem Ipsum",
      description:
        "Calcium, Phosphorus, Magnesium, Zinc, Vitamin B12 & Vitamin D3 Suspension",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab13,
    },
    {
      id: 5,
     name: "Noblefer",
      category: "Lorem Ipsum",
      description:
        "Ferric Pyrophosphate 30mg + Folic Acid 250mcg + Glycine 10mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab5,
    },
    {
      id: 6,
      name: "Zymoshine Syrup",
      category: "Lorem Ipsum",
      description: "Fungal Diastase with Pepsin",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab6,
    },
    {
      id: 7,
       name: "Etosooth-MR ",
      category: "Lorem Ipsum",
      description: "Etoricoxib 60mg + Thiocolchicoside 4mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab7,
    },
    {
      id: 8,
      name: "Semecal-D",
      category: "Lorem Ipsum",
      description: "Calcium, Magnesium, Zinc & Vitamin D3",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab8,
    },
    {
      id: 9,
      name: "Elosooth-90",
      category: "Lorem Ipsum",
      description: "Etoricoxib 90mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab12,
    
    },
    {
      id: 10,
      name: "Gerdheal20",
      category: "Lorem Ipsum",
      description:
        "Rabeprazole Sodium 20mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab10,
    },
    {
      id: 11,
      name: "Qroshine Syrup",
      category: "Lorem Ipsum",
      description: "Multivitamin, Multimineral With Lycopene & Amino Acid Syrup",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab11,
    },
    {
      id: 12,
       name: "Qroshine-TM",
      category: "Lorem Ipsum",
      description:
        "Co Enzyme Q10 100mg + EPA 90mg + DPA 60mg + Lycopene 4000mcg + L-Arginine 250mg + L-Glutaione 10mg + L-Carnitine 250mg Alpha Lipoic Acid 100mg + Vitamin B6 1mg + Vitamin E 5mg +Vitamin D3 400 I.U. + Zinc 12mg + Manganese 5mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab9,
    },
    {
      id: 13,
     name: "Semecal Total",
      category: "Lorem Ipsum",
      description:
        "Calcium Carbonate 1250 mg (Elemental Calcium 500mg) + Vit. D3 2000 IU + Methylcobalamin 1500 mcg. + L-Methylfolate Calcium 1mg + Pyridoxal-5-Phosphate 20mg Tablets",
      activeIngredient: "Lorem Ipsum is simply dummy",
      benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
      dosage:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: Tab4,
    },
  ]
  // const products = {
  //   1: {
  //     name: "GERDHEAL DSR",
  //     category: "Gastroenterology",
  //     description: "Rabeprazole Sodium 20mq 1 TABLETS",
  //     activeIngredient: "Rabeprazole Sodium - 20 mg",
  //     benefits: [
  //       "Reduces stomach acid production",
  //       "Treats GERD effectively",
  //       "Prevents ulcers",
  //       "Long-lasting relief",
  //     ],
  //     dosage: "1 tablet once daily before breakfast",
  //     image: Tab1,
  //   },
  //   2: {
  //     name: "Natodrive-MNT",
  //     category: "Lorem Ipsum",
  //     description:
  //       "Pregabalin 75mg, Mecobalamin 1500 & Nortriptyline 10mg Tablets",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab2,
  //   },
  //   3: {
  //     name: "Natodrive-SP",
  //     category: "Lorem Ipsum",
  //     description:
  //       "Aceclofenac 100mg + Paracetamol325mg & Serratiopeptidase 15mg Tablets",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab3,
  //   },

  //   4: {
  //     name: "Semecal-P",
  //     category: "Lorem Ipsum",
  //     description:
  //       "Calcium, Phosphorus, Magnesium, Zinc, Vitamin B12 & Vitamin D3 Suspension",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab13,
  //   },
  //   5: {
  //     name: "Noblefer",
  //     category: "Lorem Ipsum",
  //     description:
  //       "Ferric Pyrophosphate 30mg + Folic Acid 250mcg +Glycine 10mg Tablets",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab5,
  //   },
  //   6: {
  //     name: "Zymoshine",
  //     category: "Lorem Ipsum",
  //     description: "Fungal Diastase + Papain",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab6,
  //   },
  //   7: {
  //     name: "Etosooth-MR ",
  //     category: "Lorem Ipsum",
  //     description: "Etoricoxib 60mg+Thiocolchicoside 4mg Tablets",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab7,
  //   },
  //   8: {
  //     name: "Semecal-D",
  //     category: "Lorem Ipsum",
  //     description: "Calcium, Magnesium, Zinc & Vitamin D3",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab8,
  //   },
  //   9: {
  //     name: "Elosooth-90",
  //     category: "Lorem Ipsum",
  //     description: "Etoricoxib 90mg Tablets",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab12,
  //   },
  //   10: {
  //     name: "Gerdheal20",
  //     category: "Lorem Ipsum",
  //     description:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab10,
  //   },
  //   11: {
  //     name: "Qroshine Syrup",
  //     category: "Lorem Ipsum",
  //     description: "Multivitamin, Multimineral With Lycopene & Amino Acid",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab11,
  //   },
  //   12: {
  //     name: "Qroshine-TM",
  //     category: "Lorem Ipsum",
  //     description:
  //       "Co Enzyme Q10100mg + EPA 90mg+ DPA 60mg+Lycopene 4000mcg + L-Arginine 250mg + L-Glutaione 10mg + L-Carnitine 250mg Alpha Lipoic Acid 100mg + Vitamin B61mg + Vitamin E 5me +Vitamin D34001.U, +Zinc 12mg + Manganese 5mg TABLETS",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab9,
  //   },
  //   13: {
  //     name: "Semecal Total",
  //     category: "Lorem Ipsum",
  //     description:
  //       "Calcium Carbonate 1250mg +Magnesium Hydroxide 240mg +Zinc Sulphate 11mg+Vit. D32000 IU +Cyanocobalamin 2.2mcg +l Methylfolate Calcium 1mg+Pyradoxal 5-Phosphate 20mg TABLETS",
  //     activeIngredient: "Lorem Ipsum is simply dummy",
  //     benefits: ["lorem Ipsum", "lorem Ipsum", "lorem Ipsum", "lorem Ipsum"],
  //     dosage:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //     image: Tab4,
  //   },
  // };

  return (
    <section id="products" className="products-section">
      <div className="products-container">
        <div className="products-desc-container">
          <h2 className="products-heading">Our Flagship Products</h2>
          <p className="products-subheading">
            Comprehensive pharmaceutical solutions designed to improve patient
            outcomes and quality of life.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <Link
              to={`/products/${product.id}`}
              key={product.id}
              className="product-link"
            >
              <Card className="product-card">
                <div className="product-image-wrapper">
                  <img
                    src={product.image || "/placeholder.svg"}
                    alt={product.name}
                    className="product-image"
                  />
                </div>

                {/* <div className="product-category">
                  {product.category}
                </div> */}
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
